import { getter } from '../utils/getter.mjs'

import { UBS_META_TAGS } from './ubs/index.mjs'

export const createMetaTags = () =>
  new Proxy(
    {
      ...UBS_META_TAGS,
      default: {
        isDefault: true,
        tags: [{ tag: 'title', text: 'Ubersuggest' }],
      },
    },
    { get: getter },
  )
